import { render, staticRenderFns } from "./ButtonPadrao.vue?vue&type=template&id=e31b8e20&lang=pug"
import script from "./ButtonPadrao.vue?vue&type=script&lang=js"
export * from "./ButtonPadrao.vue?vue&type=script&lang=js"
import style0 from "./ButtonPadrao.vue?vue&type=style&index=0&id=e31b8e20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports